module.exports = __webpack_public_path__ + "img/downloads.f83f4b56.png";